import { render, staticRenderFns } from "./EmployeePersonalForm.vue?vue&type=template&id=8180ddb2&scoped=true&"
import script from "./EmployeePersonalForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeePersonalForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeePersonalForm.vue?vue&type=style&index=0&id=8180ddb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8180ddb2",
  null
  
)

export default component.exports